import { useTranslatedEventData } from 'domains/translations/hooks'
import CarouselComponent from 'ui/components/conversation/event/carousel-component'
import MessageContainer from 'ui/components/conversation/message-container'

const getItemKey = (item, idx, prefix = '') => `${prefix}${item.title}:${idx}`
const getItemLabel = (item) => item.title
const CarouselMessage = ({ event }) => {
  const { body } = useTranslatedEventData(event)
  const slides = body.cards

  return (
    <MessageContainer event={event} modifiers={'type-carousel'}>
      <CarouselComponent
        items={slides}
        getItemKey={getItemKey}
        getItemLabel={getItemLabel}
      />
    </MessageContainer>
  )
}

export default CarouselMessage
